import { Route, Routes } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import { ProtectedRouter } from 'infrastructure/routing';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { RECRUITMENT_POOL_SEARCH, RECRUITMENT_POOL_PATH } from './constants';
import RecruitmentPoolsListPage from './List/RecruitmentPoolsListPage';
import { useRecruitmentPoolRoute } from './routing';
import RecruitmentPoolDetailsPage from './show';
import RecruitmentPoolSourcingPage from './sourcing';
import { RECRUITING_SOURCING_SEARCH } from './sourcing/constants';

const RecruitmentPoolRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, sourcingRoute, singleEntityRoute } = useRecruitmentPoolRoute();

  return (
    <ProtectedRouter basePath={RECRUITMENT_POOL_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={RECRUITMENT_POOL_SEARCH}>
              <RecruitmentPoolsListPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={RECRUITMENT_POOL_SEARCH}>
              <RecruitmentPoolDetailsPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={sourcingRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={RECRUITING_SOURCING_SEARCH}>
              <RecruitmentPoolSourcingPage />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

RecruitmentPoolRouter.getRouterPath = () => `${RECRUITMENT_POOL_PATH}/*`;

export default RecruitmentPoolRouter;
